<template>
    <div id="sign-document">
        <template v-if="!sign_document_error && !complete">
          <div v-if="team && team.team" v-html="$t('image_right.team.message', { s:team.team.name })"> </div>
          <div v-if="content" v-html="content"></div>
          <div class="box-sign">
              <div>
                  <input type="checkbox" v-model="check"> <span>{{ $t(document !== 'rest_documents' ? 'image_right.sign_document_1' : 'rest_documents.sign_document') }}</span>
              </div>
              <div v-if="document !== 'rest_documents'">
                  <input type="checkbox" v-model="check2"> <span>{{ $t('image_right.sign_document_2') }}</span>
                </div>
              <div>
                  <button class="mainButton" @click="confirm">{{ $t('image_right.sign') }}</button>
              </div>
          </div>
          <div style="content: '';height:30px"></div>
      </template>
      <template v-else-if="error">
          <h1>{{ $t('image_right.titles.error') }}</h1>
          <p>{{ $t('image_right.descriptions.error') }}</p>
      </template>
      <template v-else>
          <h1>{{ $t(document !== 'rest_documents' ? 'image_right.titles.complete' : 'image_right.titles.complete_document') }}</h1>
          <template v-if="!team">
              <p v-html="$t(document !== 'rest_documents' ? 'image_right.descriptions.complete' : 'image_right.descriptions.complete_document')"></p>
              <div v-if="content" v-html="content"></div>
              <!-- {{sign_document_error.data}} -->
              <div class="box-complete">
                  <div class="label">{{ $t('params.date_id') }}:</div><div class="value">{{ sign_document_error.data.date }}</div>
                  <div class="label">{{ $t('params.name') }}:</div><div class="value">{{ sign_document_error.data.responsable.name + " " + sign_document_error.data.responsable.surname }}</div>
                  <div class="label">{{ $t('params.email') }}:</div><div class="value">{{ sign_document_error.data.responsable ? sign_document_error.data.responsable.email : sign_document_error.data.email }}</div>
              </div>
          </template>
          <template v-else>
              <p v-html="$t('image_right.descriptions.complete_team')"></p>
          </template>
      </template>
  
      <!-- Confirmation Dialog -->
      <v-dialog v-model="alertDialog" max-width="400px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-3">
            {{ $t('image_right.titles.alert') }}
          </v-card-title>
          <v-card-text>
            {{ $t('image_right.confirm_alert') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="alertDialog = false" class="black--text">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import i18n from '@/i18n'
  
  export default {
    name: 'sign-document',
  
    components: {},
  
    data () {
      return {
        total: 0,
        payed: 0,
        page: '',
        content: false,
        check: false,
        check2: false,
        complete: false,
        error: false,
        alertDialog: false
      }
    },
  
    computed: {
      user () {
        return this.$store.getters['user/getUser']
      },
  
      person () {
        return this.$store.getters['person/getPerson']
      },
  
      team () {
        let team = this.$store.getters['team/getTeam']
        return !team || Object.keys(team).length === 0 ? false : team
      },
  
      sign_document_error () {
        return this.$store.getters['getSignDocumentError']
      },
  
      document () {
        return this.$store.getters['getDocumentType']
      },
  
      isTeamComplete () {
        const team = this.team
        if (team && Object.keys(team).length > 0) {
          for (let k in team.players) {
            if (parseInt(team.players[k].image_right_status) === 0) return false
          }
          for (let k in team.staff) {
            if (parseInt(team.staff[k].image_right_status) === 0) return false
          }
          return true
        }
        return false
      }
    },
  
    methods: {
      load () {
        var self = this
        if (this.user) {
          if (this.user.entity_type === 'team') {
            this.$store
              .dispatch('team/loadTeam', {
                team_id: this.user.team_id
              })
              .then(() => {
                self.loadImageRight()
              })
          } else {
            this.$store
              .dispatch('person/loadPerson', {
                person_id: this.user.person_id
              })
              .then(() => {
                if (self.document === 'rest_documents') {
                  self.loadDocMedicines()
                } else {
                  self.loadImageRight()
                }
              })
          }
        }
      },
  
      loadImageRight () {
        if (this.user.entity_type && this.person.id && this.user.event_id) {
          this.$store
            .dispatch('person/getImageRightHtml', {
              type: this.user.entity_type,
              person_id: this.person.id,
              event_id: this.user.event_id,
              language: this.user.language,
              token: this.user.token
            })
            .then((response) => {
              this.content = response
            })
        } else if (this.user.entity_type && this.team.team.id && this.user.event_id) {
          this.$store
            .dispatch('team/getImageRightHtml', {
              team_id: this.team.team.id,
              event_id: this.user.event_id,
              language: this.user.language,
              token: this.user.token
            })
            .then((response) => {
              this.content = response
            })
        }
      },
  
      loadDocMedicines () {
        let self = this
        this.$store
          .dispatch('person/getMedicinesHtml', {
            type: this.user.entity_type,
            person_id: this.person.id,
            event_id: this.user.event_id,
            language: this.user.language,
            token: this.user.token
          })
          .then((response) => {
            self.content = response
          })
      },
  
      confirm () {
        if (this.check) {
          this.$store.dispatch('person/signDocument', {
            document: this.document === 'rest_documents' ? 'rest_documents' : 'image-right',
            type: this.user.entity_type,
            person_id: this.user.entity_type === 'team' ? this.team.team.id : this.person.id,
            event_id: this.user.event_id,
            check2: this.check2 ? 1 : 0
          }).then(() => {
            this.complete = true
            window.location.reload()
          })
        } else {
          this.alertDialog = true
        }
      }
    },
  
    created () {
      var self = this
      i18n
        .loadLanguageAsync(
          this.user.language ? this.user.language : 'ca'
        ).then(function () {
          self.load()
        })
    },
  
    watch: {
      team: {
        immediate: true,
        handler (val) {
          if (val && Object.keys(val).length > 0) {
            this.complete = this.isTeamComplete
          }
        }
      },
      sign_document_error: {
        immediate: true,
        handler (val) {
          if (val) {
            const code = parseInt(val.code)
            if (code === -1) {
              this.complete = true
            } else {
              this.error = true
            }
          }
        }
      },
      'user.language': function (newVal) {
        var self = this
        i18n.loadLanguageAsync(newVal || 'ca').then(function () {
          self.load()
        })
      }
    }
  }
  </script>
  
  <style lang="scss">
  #sign-document {
    margin-bottom: 30px;
    .row {
      margin: 10px 0;
    }
  
    span {
      font-weight: bold;
      font-size: 16px;
    }
  
    .box-sign{
      display: flex;
      margin: 30px 0;
      width: 100%;
      justify-content: center;
      line-height: 40px;
      flex-direction: column;
  
      div {
          text-align: center;
      }
  
      span {
          line-height: 40px;
          margin-left: 10px;
      }
  
      .mainButton {
          width: 150px !important;
          padding: 0;
          margin: 0;
          height: 100%;
          min-width: 40px;
          outline: none;
          cursor: pointer;
          font-size: 8pt;
          font-family: Speedee-Bold;
          border-radius: 3px;
          border: 1px solid #fc8926;
          text-transform: uppercase;
          background-color: transparent;
          color: #c55c00;
          height: 40px;
          padding: 0;
          font-family: Roboto-Bold;
          font-size: 14px;
          line-height: 14px;
          transition: background-color 0.5s ease;
  
          &:hover {
          background-color: #fc8a2623 !important;
          }
      }
  
      .success {
          border: 2px solid #087908;
          border-radius: 5px;
          background-color: #a0f8b6;
          color: #000;
          padding: 10px;
          font-size: 16px;
          text-align: center;
      }
  
      .message.error {
          background-color: #f73f2061;
          margin: 10px 0;
          border: 2px solid #e61515;
          border-radius: 5px;
          padding: 10px;
          color: #fff;
          font-weight: bold;
          text-align: center;
      }
      }
  
      .box-complete {
          height: 150px;
          display: block;
          margin-bottom: 30px;
  
          div {
              margin: 10px 0;
              width: 50%;
              float: left;
  
              &.label {
                  font-weight: bold;
              }
          }
      }
  }
  </style>